<script>
export default {
  name: 'Imbalance',
  props: ['stableData'],
  data () {
    return {
    }
  },
  computed: {
    u_level () {
      if (this.stableData && this.stableData.ua_rms > 1000 && this.stableData.ub_rms > 1000 && this.stableData.uc_rms > 1000) {
        return true
      } else {
        return false
      }
    },
    i_level () {
      if (this.stableData && this.stableData.ia_rms > 1000 && this.stableData.ib_rms > 1000 && this.stableData.ic_rms > 1000) {
        return true
      } else {
        return false
      }
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<template>
  <div class="pg">
    <!--      电度计量-->
    <div class="dataItems">
      <div class="title">三相不平衡度</div>
      <div class="dataItem">
        <div class="dataName">
          <div class="dataTitle"></div>
          <div class="dataNvItem">{{u_level?"相电压(kV)":"相电压(V)"}}</div>
          <div class="dataNvItem">{{u_level?"线电压(kV)":"线电压(V)"}}</div>
          <div class="dataNvItem">{{i_level?"电流(kA)":"电流(A)"}}</div>
        </div>
        <div class="dataValue">
          <div class="dataTitle">正序分量</div>
          <div class="dataNvItem">{{ (Number(stableData ? stableData.uph_pos : 0) / (u_level ? 1000 : 1)).toFixed(2) }}</div>
          <div class="dataNvItem">{{ (Number(stableData ? stableData.ull_pos : 0) / (u_level ? 1000 : 1)).toFixed(2) }}</div>
          <div class="dataNvItem">{{ (Number(stableData ? stableData.i_pos : 0) / (i_level ? 1000 : 1)).toFixed(2) }}</div>
        </div>
        <div class="dataValue">
          <div class="dataTitle">负序分量</div>
          <div class="dataNvItem">{{ (Number(stableData ? stableData.uph_neg : 0) / (u_level ? 1000 : 1)).toFixed(2) }}</div>
          <div class="dataNvItem">{{ (Number(stableData ? stableData.ull_neg : 0) / (u_level ? 1000 : 1)).toFixed(2) }}</div>
          <div class="dataNvItem">{{ (Number(stableData ? stableData.i_neg : 0) / (i_level ? 1000 : 1)).toFixed(2) }}</div>
        </div>
        <div class="dataValue">
          <div class="dataTitle">零序分量</div>
          <div class="dataNvItem">{{ (Number(stableData ? stableData.uph_zero : 0) / (u_level ? 1000 : 1)).toFixed(2) }}</div>
          <div class="dataNvItem">NA</div>
          <div class="dataNvItem">{{ (Number(stableData ? stableData.i_zero : 0) / (i_level ? 1000 : 1)).toFixed(2) }}</div>
        </div>
        <div class="dataValue">
          <div class="dataTitle">不平衡度(%)</div>
          <div class="dataNvItem">{{ Number(stableData ? stableData.unbal_uph : 0).toFixed(2) }}</div>
          <div class="dataNvItem">{{ Number(stableData ? stableData.unbal_ull : 0).toFixed(2) }}</div>
          <div class="dataNvItem">{{ Number(stableData ? stableData.unbal_i : 0).toFixed(2) }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
@import "../../../assets/css/stable.css";

.dataValue {
  width: 20%;
}

.dataNvItem {
  height: calc((100% - 70px)/4);
}
</style>



// WEBPACK FOOTER //
// src/pages/Stable/Imbalance/Imbalance.vue